import { render, staticRenderFns } from "./ZisPaymentComplete.vue?vue&type=template&id=48467f3f"
import script from "./ZisPaymentComplete.vue?vue&type=script&lang=js"
export * from "./ZisPaymentComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports